<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
        <div class="col-lg-12">

                    <div class="row">
                        <div class="col-md-4">
                             Customer Info:
                            <div class="card card-danger card-outline">
                                <div class="card-body">
                                    <h2>{{gatepass.branch_code}}</h2>
                                    <br>
                                    <h4>{{gatepass.first_name}} {{gatepass.last_name}}</h4>
                                    <h5>{{gatepass.primary_phone}} <span class="right badge badge-secondary"><i class="fa fa-phone"></i></span></h5>
                                    <h5>{{gatepass.alt_phone}} <span v-if="gatepass.alt_phone!=null" class="right badge badge-secondary"><i class="fa fa-phone"></i></span></h5>
                                    <br>
                                    <h5
                                        v-if="
                                                    gatepass.status == 'Converted'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    gatepass.status ==
                                                    'Action Taken - Case Closed'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    gatepass.status ==
                                                    'Feedback Call Done'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    gatepass.status ==
                                                    'Job Closed and Delivered'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-primary"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    gatepass.status ==
                                                    'Feedback Negative - Action Required'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-danger"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5 v-if="gatepass.status == 'Lost'">
                                                <span
                                                    class="right badge badge-danger"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    gatepass.status !=
                                                        'Converted' &&
                                                    gatepass.status != 'Lost' &&
                                                    gatepass.status !=
                                                        'Action Taken - Case Closed' &&
                                                    gatepass.status !=
                                                        'Feedback Call Done' &&
                                                    gatepass.status !=
                                                        'Job Closed and Delivered' &&
                                                    gatepass.status !=
                                                        'Feedback Negative - Action Required'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-secondary"
                                                >{{ gatepass.status }}</span
                                                >
                                    </h5>
                                    <br>
                                    Gatepass ID + Source + Activity + Customer Type:
                                    <br>
                                    <span class="right badge badge-primary ">{{ gatepass.id }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'CRM'" class="right badge badge-warning ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'CARE'" class="right badge badge-info ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'POS'" class="right badge badge-danger ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'ONLINE'" class="right badge badge-primary ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'ECOMMERCE'" class="right badge badge-primary ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span v-if="gatepass.entry_point == 'WACHATBOT'" class="right badge badge-success ">{{ gatepass.entry_point }}&nbsp;</span>
                                    <span class="right badge badge-secondary" @click="activityTypePrompt">{{ gatepass.activity_type }}</span>
                                    <span class="right badge badge-secondary">{{gatepass.lead_type}}</span>
                                </div>
                                <div class="card-footer">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Created By:</p
                                                <p> {{gatepass.created_by.emp_id}}</p>
                                                <p> {{gatepass.created_by.first_name}} {{gatepass.created_by.last_name}}</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p>Handled By:</p
                                                <p> {{gatepass.assigned_to.emp_id}}</p>
                                                <p> {{gatepass.assigned_to.first_name}} {{gatepass.assigned_to.last_name}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            Billing Address:
                            <div class="card card-secondary card-outline">
                                <div class="card-body">
                                    <p>{{gatepass.bill_address}}</p>
                                    <p>{{gatepass.bill_building}}</p>
                                    <p>{{gatepass.bill_street}}, {{gatepass.bill_street_no}}, </p>
                                    <p>{{gatepass.bill_block}}</p>
                                    <p>{{gatepass.bill_city}}, {{gatepass.bill_zip_code}}</p>
                                    <p>{{gatepass.bill_state}}, {{gatepass.bill_country}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            Shipping Address:
                            <div class="card card-secondary card-outline">
                                <div class="card-body">
                                    <p>{{gatepass.ship_address}}</p>
                                    <p>{{gatepass.ship_building}}</p>
                                    <p>{{gatepass.ship_street}}, {{gatepass.ship_street_no}}, </p>
                                    <p>{{gatepass.ship_block}}</p>
                                    <p>{{gatepass.ship_city}}, {{gatepass.ship_zip_code}}</p>
                                    <p>{{gatepass.ship_state}}, {{gatepass.ship_country}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    {{gatepass}}-->

        </div>
        <br>
        <div class="col-lg-12">
            <div class="card card-danger card-outline">
                <div class="card-header">
                    <div class="card-title">Status Timeline</div>
                    <div class="card-tools">
                        <!-- Collapse Button -->
                        <button class="btn btn-danger" @click="getGatepassHistory"><i class="fa fa-refresh"></i> Reload</button>
                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                    </div>
                </div>
                <div class="card-body overflow-auto">
                    <div class="row">
                        <table class="table">
                            <thead class="thead-dark">
                            <tr>
                                <th>
                                    Date &amp; Time
                                </th>
                                <th>
                                    Status
                                </th>
                                <th>
                                    Updated By
                                </th>
                                <th>
                                    Remarks
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="status in history">
                                <td>{{status.created_at | timeStamp}}</td>
                                <td>
                                    <h5
                                        v-if="
                                                    status.status == 'Converted'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    status.status ==
                                                    'Action Taken - Case Closed'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    status.status ==
                                                    'Feedback Call Done'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-success"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    status.status ==
                                                    'Job Closed and Delivered'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-primary"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    status.status ==
                                                    'Feedback Negative - Action Required'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-danger"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5 v-if="status.status == 'Lost'">
                                                <span
                                                    class="right badge badge-danger"
                                                >{{ status.status }}</span
                                                >
                                    </h5>
                                    <h5
                                        v-if="
                                                    status.status !=
                                                        'Converted' &&
                                                    status.status != 'Lost' &&
                                                    status.status !=
                                                        'Action Taken - Case Closed' &&
                                                    status.status !=
                                                        'Feedback Call Done' &&
                                                    status.status !=
                                                        'Job Closed and Delivered' &&
                                                    status.status !=
                                                        'Feedback Negative - Action Required'
                                                "
                                    >
                                                <span
                                                    class="right badge badge-secondary"
                                                >{{ status.status }}</span
                                                >
                                    </h5></td>
                                <td>{{status.created_by.user_detail}}</td>
                                <td>{{status.notes}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <br>
        <br>

        <div class="col-lg-12">
            <div class="card card-danger card-outline">
                <div class="card-header">
                    <div class="card-title">Ownership History</div>
                    <div class="card-tools">
                        <!-- Collapse Button -->
                        <button class="btn btn-danger" @click="getGatepassOwnershipHistory"><i class="fa fa-refresh"></i> Reload</button>
                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                    </div>
                </div>
                <div class="card-body overflow-auto">
                    <div class="col-sm-12">
                        <div class="row">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th>
                                        Date &amp; Time
                                    </th>
                                    <th>
                                        Assigned To
                                    </th>
                                    <th>
                                        Updated By
                                    </th>
                                    <th>
                                        Remarks
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="status in ownership">
                                    <td>{{status.created_at | timeStamp}}</td>
                                    <td>{{status.assigned_to.user_detail}}</td>
                                    <td>{{status.created_by.user_detail}}</td>
                                    <td>{{status.notes}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

			<br>
        <br>
        <div class="col-lg-12" v-if="gatepass.entry_point == 'CARE' || gatepass.activity_type=='Service'">
            <div class="card card-secondary">
                <div class="card-header">
                    <div class="card-title"><h5>Job Status Timeline</h5></div>
                    <div class="card-tools">
                        <!-- Collapse Button -->
                        <button class="btn btn-danger" @click="getGatepassJobHistory"><i class="fa fa-refresh"></i> Reload</button>
                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                    </div>
                </div>
                <div class="card-body overflow-auto">
                    <div class="col-sm-12">
                        <div class="row" v-if="job_history != ''">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th>Date &amp; Time</th>
                                    <th>Job Status</th>
                                    <th>Updated By</th>
                                    <th>Remarks</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="status in job_history">
                                    <td>
                                        {{
                                            status.created_at
                                                | timeStamp
                                        }}
                                    </td>
                                    <td>{{ status.status }}</td>
                                    <td>
                                        {{
                                            status.updated_by
                                                .user_detail
                                        }}
                                    </td>
                                    <td>{{ status.remarks }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br>

        <br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="row">
                    <div class="col-md-3">
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <div class="card-title">Update Requirement</div>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Product:</label>
                                            <v-select v-model="gatepass.product" :options="products" label="product_name" :reduce="products => products.product_name"></v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>Requirement:</label>
                                            <input class="form-control" style="width: 100% !important;" v-model="gatepass.requirement" label="Requirement" type="text">
                                        </div>
                                        <div class="form-group">
                                            <button type="button" style="width:100% !important;" class="btn btn-primary" @click="updateCustomerQuery">
                                                Update Customer Query
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <div class="card-title">Reassign Gatepass To</div>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Branch:</label>
                                            <v-select v-model="branch" style="width:100% !important;" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select destination branch" label="fullname" @input="getSalesmen"></v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>Employee:</label>
                                            <v-select
                                                v-model="salesman"
                                                style="width:100% !important;"
                                                :options="salesmen"
                                                label="user_detail"
                                                :reduce="(salesmen) => salesmen.id"
                                            ></v-select>
                                        </div>
                                        <div class="form-group">
                                            <button type="button" style="width:100% !important;" class="btn btn-primary" @click="reAssign">
                                                Re-Assign Gatepass
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <div class="card-title">Change Gatepass Status</div>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Status:</label>
                                            <v-select
                                                v-model="gpstatus"
                                                style="width:100% !important;"
                                                :options="gpstatuses"
                                                label="status"
                                                :reduce="(gpstatuses) => gpstatuses.status"
                                            ></v-select>
                                        </div>
                                        <div class="form-group" v-if="gpstatus == 'Lost'">
                                            <label>Turnaway Reason: </label>
                                            <v-select
                                                v-model="turnaway_reason"
                                                type="text"
                                                style="width:100% !important;"
                                                label="name"
                                                :options="reasons"
                                                :reduce="(reasons) => reasons.name"
                                                placeholder="Select Reason"
                                            ></v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>Notes</label>
                                            <input type="text" style="width:100% !important;" class="form-control" placeholder="Enter the notes" v-model="notes">
                                        </div>
                                        <div class="form-group">
                                            <button type="button" style="width:100% !important;" class="btn btn-primary" @click="changeStatus">
                                                Change
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="gatepass.created_by.id==user_id || $gate.isMISAdmin()||$gate.isSecondaryMISAdmin()||$gate.isCCManager()">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                <div class="card-title"><b>HANDOVER GATEPASS RIGHTS</b></div>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Branch:</label>
                                            <v-select v-model="branch" style="width:100% !important;" :options="branches" :reduce="branches => branches.branch_code" placeholder="NA" label="fullname" @input="getSalesmen" disabled></v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>Employee:</label>
                                            <v-select
                                                v-model="salesman"
                                                style="width:100% !important;"
                                                :options="salesmen"
                                                label="user_detail"
                                                :reduce="(salesmen) => salesmen.id"
                                            ></v-select>
                                        </div>
                                        <div class="form-group">
                                            <button type="button" style="width:100% !important;" class="btn btn-danger" @click="handoverGatepass">
                                                Handover
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>

        <br><br>
    </section>
       <br><br>
    <!-- /.content -->
       <div class="modal" tabindex="-1" role="dialog" id="activityTypeModal">
           <div class="modal-dialog" role="document">
               <div class="modal-content">
                   <div class="modal-header">
                       <h5 class="modal-title">Activity Type</h5>
                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                       </button>
                   </div>
                   <div class="modal-body">
                       <h5>Activity Type:&nbsp; &nbsp;<span class="right badge badge-secondary" @click="activityTypePrompt"><b>{{ gatepass.activity_type }}</b></span></h5>
                       <hr v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isCCManager()" class="dotted">
                       <div class="form-group" v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isCCManager()">
                           <span class="right badge badge-danger">Toggle Gatepass Type:</span>
                           <select class="form-control" v-model="gatepass_type">
                               <option value="Sales">Sales</option>
                               <option value="Service">Service</option>
                           </select>
                       </div>
                       <div class="form-group" v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isCCManager()">
                           <button class="btn btn-primary" @click="toggleActivityType">Toggle Type</button>
                       </div>
<!--                       <form @submit.prevent="updateEmploymentVerification">-->
<!--                           <div v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin()" :class="['form-group', errors.city ? 'has-error' : '']">-->
<!--                               <label>Verified:</label><br>-->
<!--                               <label for="html">Yes</label>-->
<!--                               <input type="radio" placeholder="Enter verification status" v-model="employment_verification" value="1">-->
<!--                               &nbsp; &nbsp;-->
<!--                               <label for="css">No</label>-->
<!--                               <input type="radio" placeholder="Enter verification status" v-model="employment_verification" value="0">-->
<!--                               <br>-->
<!--                           </div>-->
<!--                           <div class="form-group">-->
<!--                               <button class="btn btn-primary" type="submit">Submit</button>-->
<!--                           </div>-->
<!--                       </form>-->
                   </div>
                   <div class="card-footer">
                       <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                   </div>
               </div>
           </div>
       </div>



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
            this.getProducts();
        	this.getGatepass();
        	this.getSalesmen();
            this.getGPStatuses();
            this.getReasons();
            this.getBranches();
            this.user_branch = window.user.branch;
            this.user_type = window.user.user_type;
            this.user_id = window.user.id;
        },

        data(){
        	return {
        		gatepass: {},

        		gpstatuses: [],
                job_history:[],
                products:[],
                history:[],
                user_branch : '',
                user_type: '',
                user_id: '',
                gatepass_type:'',
                branches:[],
                ownership:[],
						gpstatus: "",
                branch:'',
						salesmen: [],
						salesman: "",
						turnaway_reason: "",
						reasons: [],
						notes: ''
        	}
        },

        methods: {
        	getGatepass(){
        		axios.post("/api/getGatepass", {id: this.$route.params.id})
        		.then(response => {
        			this.gatepass = response.data;
                    this.getGatepassOwnershipHistory();
                    this.getGatepassHistory();
                    if(this.gatepass.entry_point=='CARE' || this.gatepass.activity_type=='Service'){
                        this.getGatepassJobHistory();
                    }
                    // this.history = this.gatepass.gatepass_status_histories;
                    // this.ownership = this.gatepass.gatepass_ownership_histories;
        		});
        	},

            getBranches(){
                axios.post("/api/getBranches")
                    .then(response => {
                        this.branches = response.data;
                    })
            },

            getProducts(url="/api/getMasterProductList"){
                axios.post(url)
                    .then(response => {
                        this.products = response.data;
                    });
            },

            getGatepassHistory(){
                axios.post("/api/getGatepassHistory", {id: this.gatepass.id})
                    .then(response => {
                        this.history = response.data;
                    });
            },

            getGatepassJobHistory() {
                axios
                    .post("/api/getJobHistory", { gatepass_id: this.gatepass.id })
                    .then((response) => {
                        this.job_history = response.data;
                    });
            },

            getGatepassOwnershipHistory(){
                axios.post("/api/getGatepassOwnershipHistory", {id: this.gatepass.id})
                    .then(response => {
                        this.ownership = response.data;
                    });
            },

        	// getSalesmen() {
			// 			axios.post("/api/getBranchUsers", {branch: this.branch})
            //                 .then((response) => {
			// 			  this.salesmen = response.data;
			// 			});
			// 		},

            getSalesmen() {
                axios.post("/api/getBranchCallAgents")
                    .then((response) => {
                        this.salesmen = response.data;
                    });
            },

            updateCustomerQuery(){
                axios.post("/api/updateGatepassProduct", { gatepass: this.gatepass.id, product: this.gatepass.product, requirement: this.gatepass.requirement })
                    .then(() => {
                        toast.fire({
                            icon: "success",
                            title: "Updated",
                        });
                        this.getGatepass();
                    });
            },


					getGPStatuses() {
						axios.post("/api/getGPStatuses").then((response) => {
						  this.gpstatuses = response.data;
						});
					},

					getReasons() {
						axios.post("/api/getAllTAR").then((response) => {
						  this.reasons = response.data;
						});
					},

					reAssign() {
						axios
						  .post("/api/gatepassReAssign", { gatepass: this.gatepass.id, salesman: this.salesman, branch: this.branch })
						  .then(() => {
						    toast.fire({
						      icon: "success",
						      title: "Re Assigned",
						    });
						    this.getGatepass();
						  });
					},

            handoverGatepass() {
                axios
                    .post("/api/gatepassHandover", { gatepass: this.gatepass.id, salesman: this.salesman })
                    .then(() => {
                        toast.fire({
                            icon: "success",
                            title: "Handed Over",
                        });
                        this.getGatepass();
                    });
            },

					changeStatus() {
                        if(this.gpstatus!='Lost'){
                            this.turnaway_reason='';
                        }
						axios.post("/api/changeGatepassStatus", {
						    gatepass: this.gatepass.id,
						    status: this.gpstatus,
						    turnaway_reason: this.turnaway_reason,
						    notes: this.notes
						  })
						  .then(() => {
						    toast.fire({
						      icon: "success",
						      title: "Status Changed",
						    });
						    this.getGatepass();
                              if (this.gatepass.status == "Converted" && this.gatepass.activity_type == "Service") {
                                  this.$router.push("/service/new-job/" + this.gatepass.id);
                              }
						  });
					},
            activityTypePrompt(){
                console.log('Activity Type Toggler Initialized');
                this.gatepass_type=this.gatepass.activity_type;
                $("#activityTypeModal").modal("show");
            },
            toggleActivityType(){
                console.log('Toggling');
                axios.post("/api/toggleGatepassActivityType", {
                    gatepass: this.gatepass.id,
                    type: this.gatepass_type
                })
                    .then(() => {
                        toast.fire({
                            icon: "success",
                            title: "Activity Type Toggled",
                        });
                        this.getGatepass();
                    });
            }
        }
    }
</script>
